import type { DeviceDTO, PairingCodeDTO } from "../../api/contract";
import { apiDelete, apiGet, apiPatch, apiPost, buildQuery } from "./http";

export interface PairingCreatedResponse extends PairingCodeDTO {}

export function listDevices(): Promise<DeviceDTO[]> {
  return apiGet<DeviceDTO[]>("/api/extension/devices");
}

export function getDevice(id: string): Promise<DeviceDTO> {
  return apiGet<DeviceDTO>(`/api/extension/devices/${encodeURIComponent(id)}`);
}

export function renameDevice(id: string, label: string): Promise<DeviceDTO> {
  return apiPatch<DeviceDTO>(`/api/extension/devices/${encodeURIComponent(id)}`, { label });
}

export function setDeviceDeveloperMode(id: string, developerMode: boolean): Promise<DeviceDTO> {
  return apiPatch<DeviceDTO>(`/api/extension/devices/${encodeURIComponent(id)}/developer-mode`, { developerMode });
}

export function revokeDevice(id: string): Promise<void> {
  return apiDelete(`/api/extension/devices/${encodeURIComponent(id)}`);
}

export interface DeviceTaskItem {
  id: number;
  taskType: string;
  state: string;
  necrologioId: number | null;
  payload: { rawName?: string; cognome?: string; nome?: string; provincia?: string | null; comune?: string | null };
  attempts: number;
  updatedAt: string;
  error: string | null;
}

export function listDeviceTasks(id: string, limit = 30): Promise<{ items: DeviceTaskItem[] }> {
  return apiGet<{ items: DeviceTaskItem[] }>(
    `/api/extension/devices/${encodeURIComponent(id)}/tasks${buildQuery({ limit })}`,
  );
}

export function listPairings(): Promise<PairingCodeDTO[]> {
  return apiGet<PairingCodeDTO[]>("/api/extension/pairings");
}

export function createPairing(input: { label?: string } = {}): Promise<PairingCreatedResponse> {
  return apiPost<PairingCreatedResponse>("/api/extension/pairings", input);
}

export function deletePairing(id: string): Promise<void> {
  return apiDelete(`/api/extension/pairings/${encodeURIComponent(id)}`);
}

/** Versione corrente dell'estensione servita dal backend (legge manifest.json al deploy). */
export function getExtensionVersion(): Promise<{ version: string }> {
  return apiGet<{ version: string }>("/api/extension/version");
}

/** URL per scaricare lo ZIP dell'estensione Chrome (download diretto, admin). */
export function extensionDownloadUrl(): string {
  return "/api/extension/download";
}
